import styled from 'styled-components';

export const TooltipTriggerStyled = styled.span`
  /*
   * display: block gives this wrapper a real bounding box so Ant Design
   * Tooltip can measure its position (display:contents returns all-zero
   * rects, placing the tooltip at the bottom-left corner).
   *
   * In block containers (form fields) block fills the containing width, so
   * dropdowns/inputs get full width — no circular-reference shrink.
   * In flex containers (nav rows) the span becomes a flex item sized by the
   * flex algorithm, so buttons stay at their natural/explicit width.
   */
  display: block;

`;

export const InfoLabelWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
`;

export const InfoIconStyled = styled.span`
  font-size: ${(p) => p.$size ?? 14}px;
  color: ${(p) => p.theme?.colors?.tertiary ?? '#8790A4'};
  line-height: 1;
  cursor: pointer;
  transition: color 150ms ease;
  display: inline-flex;
  align-items: center;
  &:hover,
  &:focus {
    color: ${(p) => p.theme?.colors?.primary ?? '#008080'};
  }
  &:focus {
    outline: 2px solid ${(p) => p.theme?.colors?.focusShadow ?? 'rgba(0,128,128,0.2)'};
    border-radius: 2px;
  }
`;
